<script>
import Api from './Api'
export default {

  data() {
    return {
      apiToken: null,
      isError: false,
      isLoading: false,
      selectedEnvironment: Api.defaultEnvironment
    }
  },

  methods: {
    verifyApiToken() {
      this.isError = false
      this.isLoading = true
      let api = new Api(this.selectedEnvironment)
      api.verifyApiToken(this.apiToken, (success)=>{
        this.isError = !success
        this.isLoading = false
        if (success) {
          api.storeEnvironmentAsDefault()
          this.$emit('success')
        }
      })
    }
  },

  computed: {
    availableHosts() {
      return Api.hosts
    }
  }

}
</script>

<template>
  <div class="hero-body">
    <div class="container has-text-centered">

      <div class="column is-8 is-offset-2">
        <img src="../assets/luna.png" class="brand" alt="Luna">
        <br><br><br>

        <p class="subtitle has-text-grey">Please provide your MOQO API token to continue.</p>
        <div class="box">
          <form @submit.prevent="verifyApiToken">
            <b-loading :active="isLoading"></b-loading>
            <b-field label="Environment" class="has-text-left">
              <b-select v-model="selectedEnvironment">
                <option v-for="(domain, host) in availableHosts" :value="host">{{ domain }}</option>
              </b-select>
            </b-field>
            <b-field label="API token" :type="isError ? 'is-danger' : ''" class="has-text-left">
              <b-input placeholder="Bearer XYZ....." type="textarea" v-model="apiToken"></b-input>
            </b-field>

            <button class="button is-block is-link is-large is-fullwidth">Login</button>

            <br>
            <p class="is-size-7">You can create an API token in your MOQO account settings.</p>
          </form>
        </div>

      </div>

    </div>
  </div>

</template>

<style scoped>
.brand {
  max-width: 400px;
}
</style>